module.exports = __webpack_public_path__ + "img/Katarina_acc_17.04539ff7.jpg";